import { Card, CardContent, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import GridItem from "components/Grid/GridItem.jsx";
import { ParseUriParams } from "helpers/UriReader";
import React from "react";
import ClientDocuments from "../../Documents/ClientDocuments.jsx";
import ClientMessages from "../../Messaging/ClientMessages.jsx";
import ClientDetailCard from "./components/ClientDetailCard";
import QuotesTab from "./tabs/quotes/QuotesTab.jsx";

const tabStyle = {
  color: "white",
  borderBottom: "2px solid",
  opacity: "1"
};

const tabs = ["Quotes", "Documents", "Messages"];

class ClientDetailView extends React.Component {
  state = {
    tab: 0
  };

  componentDidMount() {
    const params = ParseUriParams(this.props.location.search);
    const { tab } = params;

    if (tab) {
      let tabIndex = tabs.findIndex(t => t.toLowerCase() === tab.toLowerCase());
      if (tabIndex) {
        this.setState({ tab: tabIndex });
      }
    }
  }

  handleChangeTab = (event, value) => {
    this.setState({ tab: value });
  };

  render() {
    const params = ParseUriParams(this.props.location.search);
    const { clientId, clientName } = params;

    const { tab } = this.state;
    return (
      <Grid container>
        <GridItem
          xs={12}
          sm={12}
          md={5}
          lg={4}
          style={{ marginBottom: "10px" }}
        >
          <ClientDetailCard clientId={clientId} {...this.props} />
        </GridItem>
        <GridItem xs={12} sm={12} md={7} lg={8}>
          <Card>
            <CardContent>
              <div>
                <AppBar
                  position="static"
                  color="primary"
                  style={{ marginBottom: "20px" }}
                >
                  <Tabs
                    tab={tab}
                    onChange={this.handleChangeTab}
                    scrollable
                    scrollButtons="auto"
                  >
                    {tabs.map((t, i) => {
                      return (
                        <Tab
                          label={t}
                          style={i === tab ? tabStyle : {}}
                          key={t}
                        />
                      );
                    })}
                  </Tabs>
                </AppBar>

                {tab === 0 && (
                  <QuotesTab
                    clientId={clientId}
                    clientName={clientName}
                    {...this.props}
                  />
                )}
                {tab === 1 && (
                  <ClientDocuments
                    clientId={clientId}
                    clientName={clientName}
                    {...this.props}
                  />
                )}
                {tab === 2 && (
                  <ClientMessages
                    clientId={clientId}
                    clientName={clientName}
                    {...this.props}
                  />
                )}
              </div>
            </CardContent>
          </Card>
        </GridItem>
      </Grid>
    );
  }
}

export default ClientDetailView;



// WEBPACK FOOTER //
// ./src/views/Clients/ClientDetail/ClientDetailView.jsx